<script lang="ts">
	import { ArtistsAbout } from './components/ArtistsAbout';
	import { ArtistsBio } from './components/ArtistsBio';
	import { ArtistsProjects } from './components/ArtistsProjects';
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { getArtistJsonLd } from '#lib/features/seo/utils/getArtistJsonLd/getArtistJsonLd.js';
	import { page } from '$app/state';
	import { Breadcrumbs } from '$global/components/Breadcrumbs';
	import { Container } from '$global/components/Container';
	import { JsonLd } from '$global/features/seo/components/JsonLd';
	import type { ArtistsPageData } from '$routes/artists/[slug]/types';

	let artist = $derived(page.data.artist as ArtistsPageData['artist']);
	let jsonLd = $derived(artist ? getArtistJsonLd(artist) : null);

	const dataCy = 'artist-page';

	let crumbs = $derived([
		{ label: 'Home', href: GlobalRoutes.Home },
		{ label: 'Artists', href: GlobalRoutes.ArtistsHome },
		{ label: artist?.name || '' },
	]);
</script>

{#if jsonLd}
	<JsonLd data={jsonLd} />
{/if}

<Breadcrumbs {dataCy} {crumbs} />

<Container {dataCy}>
	<ArtistsBio {dataCy} class="mt-6 mb-12 sm:mt-10" />
	<ArtistsProjects {dataCy} />
</Container>
<Container {dataCy}>
	<ArtistsAbout {dataCy} class="my-12" />
</Container>
